<template>
  <div>
    <div style="font-size: 1.25rem" class="px-4 font-weight-bold mt-4">
      {{ $vuetify.lang.t("$vuetify.ai_response.users_search_recommend") }}
    </div>
    <v-card-text>
      {{ $vuetify.lang.t("$vuetify.ai_response.input_hint") }}
    </v-card-text>
    <v-form ref="recommend_form" class="ml-4">
      <v-row>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="text" v-model="user_id" :label='$vuetify.lang.t("$vuetify.ai_response.user_id")' dense outlined :rules="[
            required(
              $vuetify.lang.t('$vuetify.ai_response.user_id')
            ),
          ]">
          </v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-btn class="mr-4 primary--text" outlined @click="generateUserUUID">
            {{ $vuetify.lang.t("$vuetify.ai_response.autogenerate") }}
          </v-btn>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="text" v-model="member_id" :label='$vuetify.lang.t("$vuetify.ai_response.member_id")' dense outlined ></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-btn class="mr-4 primary--text" outlined @click="generateMemberUUID">
            {{ $vuetify.lang.t("$vuetify.ai_response.autogenerate") }}
          </v-btn>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-select v-model="type" :items="TYPE" :label='$vuetify.lang.t("$vuetify.ai_response.gpt_search_type")' outlined required dense :rules="[
            required(
              $vuetify.lang.t('$vuetify.ai_response.gpt_search_type')
            ),
          ]">
          </v-select>
        </v-col>
        <v-col cols="6" md="6" xs="12">

        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="number" v-model="search_size" :label='$vuetify.lang.t("$vuetify.ai_response.search_size")' dense outlined
          :rules="searchSizeRules"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-select v-model="is_keyword_enabled" :items="[true, false]" :label='$vuetify.lang.t("$vuetify.ai_response.keyword_enabled")' outlined dense
          >
          </v-select>
        </v-col>
        
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="text" v-model="language" :label='$vuetify.lang.t("$vuetify.ai_response.language")' dense outlined
          :rules="[
            required(
              $vuetify.lang.t('$vuetify.ai_response.language')
            ),
          ]"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="number" v-model="top_k" :label='$vuetify.lang.t("$vuetify.ai_response.top_keyword")' dense outlined
          :rules="topKRules"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="number" v-model="start" :label='$vuetify.lang.t("$vuetify.ai_response.start")' dense outlined
          :rules="startRules"
          ></v-text-field>
        </v-col>
        <v-col cols="6" md="6" xs="12">
          <v-text-field type="number" v-model="size" :label='$vuetify.lang.t("$vuetify.ai_response.size")' dense outlined
          :rules="sizeRules"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <span>{{$vuetify.lang.t("$vuetify.ai_response.flags")}}</span>
        </v-col>
        <v-col v-for="(flagItem) in mapper.flag" :key="flagItem" cols="6" md="6" xs="12">
          <v-select v-model="flags[flagItem]" :items="[true, false]" :label="flagItem" outlined dense
          >
          </v-select>
        </v-col>
        <v-col v-if="mapper.flag.length % 2 == 1" cols="6" md="6" xs="12">

        </v-col>
        <v-col cols="12">
          <span>
            {{ $vuetify.lang.t('$vuetify.ai_response.date_range_filter') }}
          </span>
        </v-col>

      </v-row>
      <template v-if="catalogItems.length > 0">
        <v-row  v-for="(keyItem, index) in keys" :key="index">
          <v-col cols="4">
            <v-select
              clearable
              :label='$vuetify.lang.t("$vuetify.ai_response.key")'
              :items="availableKeysForField(index, keyItem.key, catalogItems)"
              outlined
              dense
              :value="keyItem.key"
              @input="onSelectChange(index, 'key', $event)"
              :rules="keyRules(keyItem.key, keyItem.comparator, keyItem.date)"
            ></v-select>
          </v-col>

          <!-- Comparator Selector -->
          <v-col cols="4">
            <v-select
              clearable
              :label='$vuetify.lang.t("$vuetify.ai_response.comparison_operator")'
              :items="filteredComparators(keyItem.key, index, keys).map(c => ({value: c, text: getComparatorText(c)}))"
              outlined
              dense
              v-model="keyItem.comparator"
              @input="onSelectChange(index, 'comparator', $event)"
              :rules="comparatorRules(index, keys)"
            ></v-select>
          </v-col>

          <!-- Date Picker -->
          <v-col cols="4">
            <v-menu
              v-model="keyItem.menu"
              max-width="290px"
              min-width="290px"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              outlined
              dense
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  @input="onSelectChange(index, 'date', $event)"
                  clearable
                  :label='$vuetify.lang.t("$vuetify.catalog.date")'
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  :value="keyItem.date"
                  outlined
                  v-on="on"
                  dense
                  :rules="dateRules(keyItem.key, keyItem.comparator, keyItem.date)"
                ></v-text-field>
              </template>
              <v-date-picker clearable v-model="keyItem.date"></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" style="margin-top: -10px;">
            <v-btn class="text-capitalize float-right ml-2" v-if="keys.length > 1" @click="removeKey" color="primary" dark>
              <span class="">
                <v-icon>mdi-minus-circle-outline</v-icon>
              </span>
            </v-btn>
            <v-btn class="text-capitalize float-right" @click="addNewKey" color="primary" dark>
              <span class="">
                <v-icon>mdi-plus-circle-outline</v-icon>
              </span>
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <v-row>
        <v-col cols="12">
          <v-btn class="ml-2" color="primary" @click="getRecommendedItems" dark>
            {{ $vuetify.lang.t("$vuetify.ai_response.get_response") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-dialog v-model="openResponseModal" max-width="90%">
      <template v-if="responseLoading" >
        <Loader  class="mr-2 mt-6" />
      </template>
      <v-card v-else class="d-flex flex-column"
        style="overflow-y: scroll; overflow-x: hidden ; min-height: 80vh; position: relative;">
        <v-container>
          <div style="font-size: 1.25rem" class="font-weight-medium mt-8">
            {{$vuetify.lang.t("$vuetify.ai_response.users_search_recommend")}}
          </div>
        </v-container>
        <v-container>
          <v-row v-if="recommendedItems && recommendedItems.length > 0">
            <v-col v-for="product in recommendedItems" :key="product[mapper.item_id]" cols="12" md="3">
              <v-card class="product-card" @click="copyItemToClipBoard(product)" outlined>
                <v-img :src="product[mapper.image_url]" height="100px">
                  <template #placeholder>
                      <div class="d-flex align-center justify-center grey--text text-caption" style="height: 100%">
                        {{ $vuetify.lang.t("$vuetify.ai_response.image_not_available") }}
                      </div>
                  </template>
                </v-img>
                <div class="card-content">
                  <p class="ml-4">{{ product[mapper.title].slice(0, 50) }}</p>
                  <strong class="ml-4">¥ {{ product[mapper.price] }}</strong>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <v-col v-else  class="d-flex align-items-center pa-0">
            <v-icon class="text-info mr-2">mdi-information</v-icon>
            <span class="text-body-1">
              {{ $vuetify.lang.t("$vuetify.ai_response.recommended_items_not_found") }}
            </span>
          </v-col>
        </v-container>
        <v-divider></v-divider>
        <v-card-title>
          <v-card-actions class="justify-end" style="position: absolute; bottom: 0; right: 0;">
            <v-btn color="primary" text @click="openResponseModal=false">{{$vuetify.lang.t("$vuetify.ai_response.close")}}</v-btn>
          </v-card-actions>
        </v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import {USERS_SEARCH_RECOMMEND, ADD_ALERT} from "@/store/_actiontypes";
import { mapState, mapActions } from "vuex";
import Loader from "@/components/common/loader/Loader";
import { filteredComparators, comparatorRules, keyRules, dateRules, availableKeysForField, getComparatorText} from '../../Recommendation/shared_libs';
export default {
  components: {
    Loader
  },
  props: {
    mapper: {
      type: Object,
    },
    catalogItems: {
      type: Array
    }
  },
  data() {
    return {
      user_id: "",
      member_id: "",
      item_id: "",
      openModal: false,
      openResponseModal: false,
      recommendedItems : [],
      responseLoading: false,
      type: "",
      storage: "",
      search_size: 1,
      language: "en",
      flags : {},
      is_keyword_enabled: true,
      start: 0,
      keys: [
        {key: "", date: "", comparator: "",  menu: false},
      ],
      size: 10,
      top_k: 20,
      selectedKeys: {},
      startRules: [
        value => value === "" || value >= 0 || `${this.$vuetify.lang.t("$vuetify.ai_response.min_value_error")} 0`,
      ],
      sizeRules: [
        value => value === "" || value >= 1 || `${this.$vuetify.lang.t("$vuetify.ai_response.min_value_error")} 1`,
      ],
      TYPE: ["individual", "group"],
      STORAGE: ["memory", "database"],
      searchSizeRules: [
        value => value >= 1 || `${this.$vuetify.lang.t("$vuetify.ai_response.min_value_error")} 1`,
      ],
      topKRules: [
        value => value >= 1 || `${this.$vuetify.lang.t("$vuetify.ai_response.min_value_error")} 1`,
        value => value <= 20 || `${this.$vuetify.lang.t("$vuetify.ai_response.max_value_error")} 20`,
      ],

    };
  },
  computed: {
    ...mapState({
      selectedProject: (state) => state.project.selectedProject,
      user: (state) => state.account.user
    }),
    catalogKeys(){
      const keys = Object.keys(this.catalogItems[0]?.item)
      return keys
    },
  },
  methods: {
    ...mapActions("ai_response", [USERS_SEARCH_RECOMMEND]),
    ...mapActions("alert", [ADD_ALERT]),
    filteredComparators,
    comparatorRules,
    keyRules,
    dateRules,
    availableKeysForField,
    getComparatorText,
    required(fieldName) {
      return (value) => !!value || `${fieldName} ${this.$vuetify.lang.t("$vuetify.ai_response.is_required")}`;
    },
    addNewKey(){
      this.keys.push({key: "", date: "", comparator: "",  menu: false})
    },
    removeKey(){
      const keysLength = this.keys.length
      if(keysLength > 1){
        const key = this.keys[keysLength-1].key
        if(this.selectedKeys[key])
          this.selectedKeys[key] = this.selectedKeys[key] - 1
        this.keys.pop()
      }
    },
    onSelectChange(index, field, value) {
      if (value === null) {
        this.keys[index][field] = "";
      } else {
        this.keys[index][field] = value;
      }
      let keyValues = {}
        this.keys.forEach((key) => {
          if( key.key && keyValues[key.key] == null){
            keyValues[key.key] = 1
          }
          else if( key.key && keyValues[key.key] != null){
            keyValues[key.key] = keyValues[key.key] + 1
            const indexes = []
            this.keys.forEach((item, index)=> {
              if(item.key == key.key){
                indexes.push(index)
                return true
              }
              return false
            })
            const subStr = (this.keys[indexes[0]].comparator.includes("gt") && this.keys[indexes[1]].comparator.includes("gt")) || (this.keys[indexes[0]].comparator.includes("lt") && this.keys[indexes[1]].comparator.includes("lt"))
            if( subStr ){
              this.keys[indexes[1]].comparator = ""
            }
          }
        })
        this.selectedKeys = keyValues
        setTimeout(()=> {
          this.validateForm()
        }, 100)
    },
    generateMemberUUID() {
      this.member_id = uuidv4()
    },
    generateUserUUID() {
      this.user_id = uuidv4()
    },
    copyItemToClipBoard(item){
      navigator.clipboard.writeText(JSON.stringify(item, null, 2));
      this.$store.dispatch(
                `alert/${ADD_ALERT}`, {
                  message: this.$vuetify.lang.t("$vuetify.ai_response.item_copied_message"),
                  color: "success",
                }, { root: true }
              );
    },
    setItemId(itemId){
      this.item_id = itemId
      this.openModal = false
    },
    getFormData(){
      return {
        member_id : this.member_id,
        user_id: this.user_id,
        item_id: this.item_id,

      }
    },
    validateForm() {
      return this.$refs.recommend_form.validate();
    },
    getRecommendedItems(){
      const valid = this.validateForm()
      if(!valid) return
      const keys = {}
      this.keys.forEach(keyItem => {
          if(keys[keyItem.key] && keyItem.key)
            keys[keyItem.key] = {...keys[keyItem.key], key: keyItem.key, [keyItem.comparator] : keyItem.date}
          else if (keyItem.key)
            keys[keyItem.key] = {key: keyItem.key, [keyItem.comparator] : keyItem.date}
      })
      const date_range_filters = Object.values(keys)
      let flags = {}
      if(Object.keys(this.flags).length > 0){
        flags = this.flags
      }

      const optionalPayloads = {}

      if(this.start !== ""){
        optionalPayloads.start = Number.parseInt(this.start)
      }
      if(this.size !== ""){
        optionalPayloads.size = Number.parseInt(this.size)
      }
      this.openResponseModal = true
      this.responseLoading = true
      this.USERS_SEARCH_RECOMMEND({
        project_id: this.selectedProject.id,
        user_id: this.user_id,
        member_id: this.member_id,
        type: this.type,
        search_size: Number.parseInt(this.search_size),
        language: this.language,
        top_k: Number.parseInt(this.top_k),
        date_range_filters,
        ...optionalPayloads,
        flags,
        is_keyword_enabled: this.is_keyword_enabled
      }).then(
        (response) => {
          this.responseLoading = false
          this.recommendedItems = response.data.detail.response
        },
        (error) => {
          console.error("error", error)
          if(error.status === 422){
            this.$store.dispatch(
                  `alert/${ADD_ALERT}`, {
                    message: JSON.stringify(error?.response?.data?.detail),
                    color: "error",
                  }, { root: true }
                );
          } else {
            this.$store.dispatch(
                  `alert/${ADD_ALERT}`, {
                    message: error?.response?.data?.detail?.response,
                    color: "error",
                  }, { root: true }
            );
          }
          this.openResponseModal = false
        }
      );
    },
  }
};
</script>

<style scoped>
        .product-card {
          height: 300px; 
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          cursor: pointer;
        }
        .card-content {
          padding: 4px;
        }
    
        .card-content .v-card-title {
          margin-bottom: 0;
          font-size: 16px;
        }
    
        .card-content .v-card-subtitle {
          margin-bottom: 8px;
        }
</style>
